import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { ActivatedRoute, Router } from "@angular/router"
import { Subscription } from "rxjs"
import { NotificationService } from '../../../../notification/shared/notification.service'
import { BasketService } from '../../../basket/shared/basket.service'
import { ClientService } from "../../../shared/client/client.service"
import { Porteur } from '../shared/porteur'
import { PorteurService } from '../shared/porteur.service'
import { DelValidationComponent } from './del-validation/del-validation.component'

@Component({
  selector: 'app-porteur',
  templateUrl: './porteur.component.html',
  styleUrls: ['./porteur.component.scss']
})
export class PorteurComponent implements OnInit, OnDestroy {

  @Input()
  porteur: Porteur;
  load: Subscription = new Subscription();

  constructor(
    private porteurService: PorteurService,
    private basketService: BasketService,
    private notificationService: NotificationService,
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private clientService: ClientService,
  ) { }

  ngOnDestroy() {
    this.load.unsubscribe();
  }

  ngOnInit() { }

  private success() {
    this.notificationService.notif("La demande de retrait a été ajoutée au panier. Elle sera automatiquement supprimée sous 2 jours si elle n'est pas validée.", "notif");
  }

  private openDialog(porteur: Porteur) {
    const dialogRef = this.dialog.open(DelValidationComponent, {
      data: {
        porteur: porteur
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.performDelete();
      }
    });
  }

  private performDelete() {
    this.basketService.addBasketLine({
      type: "RETRAIT PORTEUR",
      numPorteur: this.porteur.numPorteur,
      codeService: this.porteur.codeService
    }).subscribe(
      ret => this.success()
    );
  }

  delete() {
    this.openDialog(this.porteur);
  }

  showDetails() {
    this.clientService.modifCodeService = this.porteur.codeService;
    this.router.navigate([`${this.porteur.numPorteur}`], {
      relativeTo: this.route.parent
    });
  }
}
